const ChessImageGenerator = require('./chess-image-generator');

module.exports = ChessImageGenerator;
